import styled from 'styled-components';

export const ShareRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--spacing-sm);
  min-width: 0;
`;

export const ShareLabel = styled.span`
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--text-secondary);
  margin-right: var(--spacing-xs);
`;

const buttonBase = `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 40px;
  padding: 0 14px;
  border-radius: var(--radius-round);
  border: 1.5px solid var(--border-medium);
  background: var(--bg-card);
  color: var(--text-primary);
  font-family: var(--font-brand);
  font-size: var(--text-sm);
  font-weight: 600;
  line-height: 1;
  text-decoration: none;
  cursor: pointer;
  transition: all var(--transition-fast);

  &:hover {
    border-color: var(--primary);
    color: var(--primary);
    background: var(--primary-subtle);
  }

  &:focus-visible {
    outline: 2px solid var(--border-focus);
    outline-offset: 2px;
  }
`;

export const ShareLink = styled.a`
  ${buttonBase}
`;

export const ShareAction = styled.button`
  ${buttonBase}
`;

export const CopiedNote = styled.span`
  font-size: var(--text-xs);
  font-weight: 600;
  color: var(--success-dark);
`;
